import { supabase } from "@/lib/supabase";
import type { PrivateLesson } from "./lessons";

interface PrivateLessonReservationPayload {
  privateLesson: PrivateLesson;
  client: {
    id: string;
    name: string;
    email: string;
  };
  reservation: {
    lessonDate: string;
    lessonTime: string;
    durationHours: number;
    lessonType: "single" | "pair";
    lessonTypeLabel: string;
    danceStyle?: string;
    notes?: string;
  };
}

export const n8nApi = {
  async notifyPrivateLessonReservation(
    payload: PrivateLessonReservationPayload,
  ): Promise<{ success: boolean; error?: string }> {
    try {
      const {
        data: { session },
      } = await supabase.auth.getSession();

      if (!session?.access_token) {
        return {
          success: false,
          error: "Na odoslanie n8n notifikácie sa treba prihlásiť.",
        };
      }

      const response = await fetch("/api/n8n-private-lesson-notify", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${session.access_token}`,
        },
        body: JSON.stringify({
          private_lesson_id: payload.privateLesson.id,
          ...payload,
        }),
      });

      const data = await response.json().catch(() => ({}));

      if (!response.ok) {
        return {
          success: false,
          error:
            data && typeof data === "object" && "error" in data
              ? String(data.error)
              : `n8n notify failed with status ${response.status}`,
        };
      }

      return { success: true };
    } catch (error) {
      return {
        success: false,
        error: error instanceof Error ? error.message : "Unknown n8n error",
      };
    }
  },
};
